import { usePage } from "@inertiajs/vue3";

export default function () {
    const recaptchaSiteKey = usePage().props.recaptcha;

    const getRecaptchaToken = (action) => {
        return new Promise((resolve, reject) => {
            window.grecaptcha.ready(() => {
                window.grecaptcha
                    .execute(recaptchaSiteKey, { action })
                    .then((token) => resolve(token))
                    .catch((error) => reject(error));
            });
        });
    };

    return {
        recaptchaSiteKey,
        getRecaptchaToken,
    };
}
